export default __webpack_public_path__ + "assets/svg/Machine.638c13ea3e68ce6afa07a08bbe9065fd.svg";